var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AtomLink',{class:_vm.css(),attrs:{"open-in-new-tab":true,"size":_vm.AtomLinkSizeEnum.REGULAR,"route":_vm.url}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }